import { render, staticRenderFns } from "./BaseIndicator.vue?vue&type=template&id=0b001944&scoped=true&"
import script from "./BaseIndicator.vue?vue&type=script&lang=ts&"
export * from "./BaseIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./BaseIndicator.vue?vue&type=style&index=0&id=0b001944&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b001944",
  null
  
)

export default component.exports